/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHomeHeart} from '@fortawesome/pro-duotone-svg-icons';

const HomeroomsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faHomeHeart} {...props} />
);

export default HomeroomsIcon;
